import { combineReducers } from "redux";
import company from "../features/admin/company/company/slice";

const Companys = combineReducers({
  company: company,
});

export default Companys;
